import { Module } from '@nestjs/common';
import { RoleMasterController } from './role-master.controller';
import { RoleMasterService } from './role-master.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import {RolesAdapter} from './dto/role-adapter';
import { Roles } from './role-entity'
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({

  imports: [
    
    TypeOrmModule.forFeature([Roles]),
     ],
  controllers: [RoleMasterController],
  providers: [RoleMasterService,RolesAdapter,ApplicationExceptionHandler,LogsService],
  exports:[RoleMasterService],
})
export class RoleMasterModule {}
